import { render, staticRenderFns } from "./LineaTiempoTabContent.vue?vue&type=template&id=2d051bc7"
import script from "./LineaTiempoTabContent.vue?vue&type=script&lang=js"
export * from "./LineaTiempoTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports